import { ContentType, ImageOrientation, TranslationContentType } from "../../core/shared/contentTypes";
import { RecipeLinkingDataModel, NutritionViewModel, ProductExtraPricesModel, ProductPricesModel, ScheduledForRequest, ScheduleView, BaseUnit } from "../../core/shared/models";
import { SOTProductViewModel, SOTProductExtraGroupViewModel } from "./product.model";
import { ISOTProductViewModel, ISOTProductDetailViewModel } from "./product.facade";
import { InternationalisationService } from "../../core/forked/angular-internationalisation";
import Utils from "../../core/shared/utils";
import { CoreLanguageManager } from "../../core/services/ILanguageManager";

// ViewModel
export class SOTRecipeLinkingViewModel implements ISOTProductViewModel {

  public get is_recipe_linking(): boolean {
    return true; // ist eine Rezeptrutverkettung
  }
  /** artikel product_id */
  public get product_id(): number {
    return -(this._model.id); // Rezepturverkettungen haben selbst keine ProductID
  }
  /** artikel_nr */
  public get artikel_nr(): number {
    return this._model.item_number;
  }
  /** free_item_nr */
  public get free_item_nr(): number {
    return +(this._model.free_item_number);
  }

  /** artikel bezeichnung */
  public get label(): string {
    const _name = InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.name_en) ? this._model.name_de : this._model.name_en;
    return CoreLanguageManager.translate(TranslationContentType.RecipeLinking_Name, this._model.id, _name);
  }

  /**Überschrift*/
  public get heading(): string {
    const _headline = InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.headline_en) ? this._model.headline_de : this._model.headline_en;
    return CoreLanguageManager.translate(TranslationContentType.RecipeLinking_Heading, this._model.id, _headline);
  }

  /** hat abfragen */
  public get has_extras(): boolean {
    return true; // Rezepturverkettungen können nicht sofort gebucht werden, es muss ein Artikel gewählt werden
  }

  public get has_subextras(): boolean {
    return true;
  }

  /** prüfung ob der artikel verfügbar ist */
  public get is_available(): boolean {
    const firstAvalibleProduct = this.sotProducts.find((sotProduct) => sotProduct.is_available)
    return firstAvalibleProduct !== undefined;
  }

  /** ermmitelt bei bedarf die Preise
   * ! Achtung beinflust getProductExtras (es resetet den cache)
   */
  public getPrices(): ProductPricesModel {
    throw new Error("getPrices not implementet yet");
  }

  /** ermittelt die Extras und die Preise, man kann es umstellen, dass die Preise extra ermittelt werden, um die Extras nicht neu zu ermitteln
   * ! Achting es ist von getPrices abhängig, nutzt den gleichen cache
   */
  public get extraGroups(): SOTProductExtraGroupViewModel[] {
    return []; // ist eine Rezeptrutverkettung
  }

  public get linkedProducts(): ISOTProductViewModel[] {
    return this.sotProducts;
  }

  /** angewandte beste Preisebene */
  public get bestPE(): number {
    return 0; // ist eine Rezeptrutverkettung
  }
  /** artikel preis ohne rabatt (ohne die extras) */
  public get price(): number {
    return 0; // ist eine Rezeptrutverkettung
  }
  /** artikel preis mit rabatt (ohne die extras) */
  public get discountPrice(): number {
    return 0; // ist eine Rezeptrutverkettung
  }
  /** theoretischer preis mit zwangs extras und rabatt */
  public get priceWithExtras(): number {
    return 0; // ist eine Rezeptrutverkettung
  }
  public get deposit(): number {
    return 0; // ist eine Rezepturverkettung
  }
  public get has_deposit(): boolean {
    return this.deposit > 0;
  }
  public get depositWithExtras(): number {
    return 0; // ist eine Rezepturverkettung
  }
  public get has_depositWithExtras(): boolean {
    return this.depositWithExtras > 0;
  }
  /** hilfs function um preise für extras zu bekommen */
  public getExtraPrices(extra_id: number): ProductExtraPricesModel {
    return this.getPrices().extras[extra_id];
  }

  /** anzeige preis, welcher dem anwender angezeigt wird (base mit extras und mit oder ohne pfand) */
  public get show_price(): number {
    if (this.sotProducts.length > 0) {
      // gets the min price from all products
      return Math.min(...this.sotProducts.map(product => product.show_price))
    } else {
      return 0;
    }
  }

  private _details: SOTRecipeLinkingDetailsViewModel;
  /** details zum artikel */
  public get details(): ISOTProductDetailViewModel {
    return this._details;
  }

  /** Enthält die durch refreshSchedule ermittelten Zeitsteuerungs Informationen */
  public schedule: ScheduleView = new ScheduleView();
  /** aktualisiert schedule */
  public refreshSchedule(schedule_req: ScheduledForRequest): void {
    const me = this;
    let some_active = false;
    let some_visible = false;
    // todo momentan wird der hint nicht betrachtet (bei kochlöfel) später sollte es beachtet werden
    me._originalSotProducts.forEach((product) => {
      product.refreshSchedule(schedule_req);
      some_active = some_active || product.schedule.active;
      some_visible = some_visible || !product.schedule.hide;
      // hint? Keine Eingabemöglichkeit bei Rezepturverkettungen im Portal
    });
    me.schedule.active = some_active;
    me.schedule.hide = !some_visible;
    //me.schadule.hint = "";
    me._sotProducts = null; //refresh sotProducts
  }

  public get has_image(): boolean {
    return this._model.last_image_update_at_ymd > 0
  }
  public get image_path(): string {
    if (this.has_image)
      return ContentType.RecipeLinking + "/" + this._model.id + "_photo_" + ImageOrientation.Landscape + "/" + this._model.last_image_update_at_ymd + "/" + this._model.last_image_update_at_hms;
    else
      return "";
  }
  /** cache der berechneten Artikel TAGs */
  private _product_tag_ids: number[] = null;
  /** Liste der zugeordneten Artikel TAG IDs */
  public get product_tag_ids(): number[] {
    const me = this;
    // bei einer Rezepturverkättung erhält die Verkettung alle TAGs der Rezepturen
    if (me._product_tag_ids === null) {
      me._product_tag_ids = [];
      if (me.sotProducts) {
        me.sotProducts.forEach(sotProduct => {
          me._product_tag_ids.push(...sotProduct.product_tag_ids);
        });
        // uniqe ids
        me._product_tag_ids = me._product_tag_ids.filter((v, i, a) => a.indexOf(v) === i);
      } // else keine Artikel TAGs
    } // else nutze ermittelte Artikel TAGs
    return me._product_tag_ids;
  }
  /** ursprungliche SOT-Produkte */
  private _originalSotProducts: SOTProductViewModel[];
  /** hat die Verkettung ursprungliche SOT-Produkte (auch die welche nicht verfügbar sind) */
  public get hasOriginalSotProducts(): boolean {
    return this._originalSotProducts.length > 0;
  }
  /** anzuzeigende SOT-Produkte */
  private _sotProducts: SOTProductViewModel[] = null;
  /** Produkte die angezeigt werden sollen */
  public get sotProducts(): SOTProductViewModel[] {
    const me = this;
    if (me._sotProducts == null) {
      // Filtere nur aktive und nicht versteckte Produkte
      me._sotProducts = me._originalSotProducts.filter((product) => product.schedule.active || !product.schedule.hide);
    }
    return me._sotProducts;
  }

  private _model: RecipeLinkingDataModel;
  public get model(): RecipeLinkingDataModel {
    return this._model;
  }

  constructor(model: RecipeLinkingDataModel,
    sotProducts: SOTProductViewModel[],
    productTagFilter: number[],
    sortFunction: (a: ISOTProductViewModel, b: ISOTProductViewModel) => number,
  ) {
    const me = this;
    me._model = model;
    me._details = new SOTRecipeLinkingDetailsViewModel(me);

    const subProductIDs = model.products.map((product) => product.product_id);

    let filtered = sotProducts
      .filter((sotProduct) => subProductIDs.includes(sotProduct.product_id));

    if (productTagFilter && productTagFilter.length > 0) {
      const matchesTagFilter = (tags: number[]) =>
        productTagFilter.every(tag => tags.includes(tag));

      filtered = filtered.filter(p => matchesTagFilter(p.product_tag_ids));
    }

    me._originalSotProducts = filtered.sort(sortFunction);
  }
  extra: string;
}

export class SOTRecipeLinkingDetailsViewModel implements ISOTProductDetailViewModel {

  public get description(): string {
    const _details = InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.model.details_en) ? this._model.model.details_de : this._model.model.details_en;
    return CoreLanguageManager.translate(TranslationContentType.RecipeLinking_Details, this._model.model.id, _details);
  }
  public get co2(): number {
    return 0;
  }
  private _nutritions: NutritionViewModel;
  public get nutritions(): NutritionViewModel {
    return this._nutritions;
  }
  public get additives(): string[] {
    return [];
  }
  public get allergens(): string[] {
    return [];
  }
  public get item_Content(): string {
    return "";
  }
  public get alcohol_Content(): number {
    return 0;
  }
  public get caffeine_Content(): number {
    return 0;
  }
  public get hasContentLevel(): boolean {
    return false;
  }
  public get item_Base_Unit(): BaseUnit {
    return BaseUnit.NONE;
  }
  public get item_Base_Factor(): number {
    return 0;
  }
  public get item_Base_Price(): number {
    return 0;
  }
  public get item_Provider_Name(): string {
    return "";
  }
  public get item_Provider_Addr(): string {
    return "";
  }
  public get hasProvider_Info(): boolean {
    return false;
  }
  public get model(): RecipeLinkingDataModel {
    return this._model.model;
  }
  public get is_recipe_linking(): boolean {
    return true;
  }
  public get prepackaged(): boolean {
    return false;
  }

  private _model: SOTRecipeLinkingViewModel;

  constructor(model: SOTRecipeLinkingViewModel) {
    const me = this;
    me._model = model;

    me._nutritions = new NutritionViewModel();
    me._nutritions.headerDE = "";
    me._nutritions.headerEN = "";
    me._nutritions.nutritionItemViewModelsDE = [];
    me._nutritions.nutritionItemViewModelsEN = [];
  }
}
